/**
 * Live countdown for local status-overlay auto-hide (hard-coded PT like CurrentState).
 */

export function formatLocalStatusOverlayAutoHideRemaining(
  untilMs: number,
  nowMs: number
): string | null {
  if (!Number.isFinite(untilMs) || untilMs <= 0 || !Number.isFinite(nowMs)) {
    return null
  }
  const remainMs = untilMs - nowMs
  if (remainMs <= 0) {
    return null
  }
  const totalSec = Math.max(1, Math.ceil(remainMs / 1000))
  const minutes = Math.floor(totalSec / 60)
  const seconds = totalSec % 60
  if (minutes > 0) {
    return `${minutes}m ${String(seconds).padStart(2, '0')}s`
  }
  return `${seconds}s`
}
